var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamingOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile_no_conn_01",
    transform: "translate(-1405.000000, -140.000000)",
    fill: "#3C3C3C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video_01",
    transform: "translate(1270.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-off",
    transform: "translate(135.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00526316,0 L0,2.00526316 L4.31052632,6.31578947 L3.15789474,6.31578947 C2.28586618,6.31578947 1.57894737,7.02270829 1.57894737,7.89473684 L1.57894737,23.6842105 C1.57894737,24.5562391 2.28586618,25.2631579 3.15789474,25.2631579 L22.1052632,25.2631579 C22.4210526,25.2631579 22.7210526,25.1368421 22.9578947,24.9789474 L27.9947368,30 L30,27.9947368 M30,7.10526316 L23.6842105,13.4210526 L23.6842105,7.89473684 C23.6842105,7.02270829 22.9772917,6.31578947 22.1052632,6.31578947 L12.3473684,6.31578947 L30,23.9684211 L30,7.10526316 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamingOff);
export default __webpack_public_path__ + "static/media/streamingOff.dec6766e655f9edfd90a5493cc5b65d6.svg";
export { ForwardRef as ReactComponent };